import type { Rule } from 'antd/es/form';

export const requiredRule: Rule = {
  required: true,
  message: 'This field is required',
};

export const maxCharactersRule = (maxCharacters: number): Rule => {
  return {
    max: maxCharacters,
    message: `Max ${maxCharacters} characters`,
  };
};
